import * as React from 'react';
import { AppProvider } from '@toolpad/core/AppProvider';
import { SignInPage } from '@toolpad/core/SignInPage';
import { useTheme } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import { login } from './api'; // 确保引入 login 函数
import AuthContext from './AuthContext'; // 导入 AuthContext

const providers = [{ id: 'credentials', name: 'Email and Password' }];

export default function LoginPage() {
    const { token, setToken: setTokenAndFetchUserInfo, tokenExpired } = React.useContext(AuthContext);
    const navigate = useNavigate();
    const theme = useTheme();

    // 如果 token 存在且没有过期，直接跳转到 homePage
    React.useEffect(() => {
        if (token && !tokenExpired) {
            navigate('/homePage');
        }
    }, [token, tokenExpired, navigate]); // 监听 token 和 tokenExpired 的变化

    const signIn = async (provider, formData) => {
        const email = formData.get('email');
        const password = formData.get('password');

        try {
            const data = await login(email, password);
            const token = data.token;

            // Store token in local storage and fetch user info
            setTokenAndFetchUserInfo(token);
            return token; // Return token if needed
        } catch (error) {
            throw new Error('Login failed');
        }
    };

    const handleSignIn = async (provider, formData) => {
        try {
            await signIn(provider, formData);
            navigate('/homePage'); // On successful sign-in, navigate to the home page
        } catch (error) {
            alert(error.message); // Handle error (e.g., show message to user)
        }
    };

    return (
        <AppProvider theme={theme}>
            <SignInPage signIn={handleSignIn} providers={providers} />
        </AppProvider>
    );
}
